import {Routes} from '@angular/router';
import userSearchPageRoutes from './search/user-search-page.routing';
import {AuthInfo} from '../../components/security/authorization/auth.guard';

/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
const routes: Routes = [{
    path: 'admin',
    children: (<Routes>[
        {path: '', redirectTo: 'search/users', pathMatch: 'full'}
    ]).concat(
        userSearchPageRoutes
    ),
    data: {auth: new AuthInfo({roles: ['ADMIN']})}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/admin-pages.routing.ts